// (A) 중립 Spinner API — antd 미접촉. (B) PlainSpinner 에 위임.
import type { CSSProperties, ReactNode } from 'react'
import { PlainSpinner } from '../_impl/PlainSpinner'

export interface OmwSpinnerProps {
  spinning?: boolean
  size?: 'small' | 'default' | 'large'
  tip?: ReactNode
  /** children 래핑 시 nested-loading 래퍼 추가 클래스. */
  wrapperClassName?: string
  className?: string
  style?: CSSProperties
  children?: ReactNode
}

export function OmwSpinner(props: OmwSpinnerProps) {
  return <PlainSpinner {...props} />
}
